// @ts-nocheck
import { t } from '../../services/i18n';

/**
 * WelcomeScreen - Gère l'affichage de l'écran d'accueil quand aucun stream n'est affiché
 */
export class WelcomeScreen {
    constructor() {
        this.container = document.getElementById('welcome-screen');
        this.streamsContainer = document.getElementById('streams-container');
        window.addEventListener('interface-language-change', () => this.createWelcomeContent());
        
        // Initialiser l'écran d'accueil
        this.init();
    }
    
    /**
     * Initialise l'écran d'accueil
     */
    init() {
        // Créer le contenu de l'écran d'accueil
        this.createWelcomeContent();
        
        // Observer les changements dans le conteneur de streams
        this.setupStreamObserver();
    }
    
    /**
     * Crée le contenu de l'écran d'accueil
     */
    createWelcomeContent() {
        this.container.innerHTML = `
            <main class="welcome-shell">
                <section class="welcome-hero">
                    <div class="welcome-hero-copy">
                        <div class="welcome-eyebrow"><span></span>${t('welcome.eyebrow')}</div>
                        <h1 class="welcome-title">${t('welcome.heroTitle')} <em>${t('welcome.heroAccent')}</em></h1>
                        <p class="welcome-subtitle">${t('welcome.subtitle')}</p>
                        <div class="quick-actions">
                            <button class="action-button" id="search-streamer-btn"><i class="fas fa-search"></i><span>${t('welcome.search')}</span></button>
                            <button class="action-button secondary" id="browse-combos-btn"><i class="fas fa-layer-group"></i><span>${t('welcome.browse')}</span></button>
                            <button class="action-button secondary resume-streams-btn" id="resume-streams-btn" hidden><i class="fas fa-play"></i><span>${t('welcome.resume')}</span></button>
                        </div>
                        <div class="welcome-trust-row">
                            <span><i class="fas fa-bolt"></i>${t('welcome.fast')}</span>
                            <span><i class="fas fa-link"></i>${t('welcome.shareable')}</span>
                            <span><i class="fas fa-sliders-h"></i>${t('welcome.flexible')}</span>
                        </div>
                    </div>
                    <div class="welcome-visual" aria-hidden="true">
                        <div class="welcome-glow"></div>
                        <div class="welcome-logo-card"><img src="/static/images/logo.png" alt=""><span>MultiStream</span></div>
                        <div class="welcome-player-grid">
                            <span class="welcome-player-card primary"><i class="fas fa-play"></i></span>
                            <span class="welcome-player-card"><i class="fas fa-play"></i></span>
                            <span class="welcome-player-card"><i class="fas fa-play"></i></span>
                        </div>
                        <div class="welcome-live-pill"><span></span>${t('welcome.live')}</div>
                    </div>
                </section>

                <section class="features-section">
                    <article class="feature-card"><div class="feature-icon"><i class="fas fa-th-large"></i></div><div><h3 class="feature-title">${t('welcome.multipleTitle')}</h3><p class="feature-description">${t('welcome.multipleText')}</p></div></article>
                    <article class="feature-card"><div class="feature-icon"><i class="fas fa-volume-up"></i></div><div><h3 class="feature-title">${t('welcome.audioTitle')}</h3><p class="feature-description">${t('welcome.audioText')}</p></div></article>
                    <article class="feature-card"><div class="feature-icon"><i class="fas fa-layer-group"></i></div><div><h3 class="feature-title">${t('welcome.combosTitle')}</h3><p class="feature-description">${t('welcome.combosText')}</p></div></article>
                </section>

                <section class="combo-section">
                <div class="section-header">
                    <h2 class="section-title">
                        <i class="fas fa-star"></i> ${t('welcome.featured')}
                    </h2>
                </div>
                <div class="combo-list" id="featured-combos">
                    <!-- Featured combos will be loaded here -->
                </div>
                </section>

                <section class="combo-section">
                <div class="section-header">
                    <h2 class="section-title">
                        <i class="fas fa-user"></i> ${t('welcome.yours')}
                    </h2>
                    <div class="section-actions">
                        <button class="compact-btn" id="manage-all-combos-btn">
                            <i class="fas fa-cog"></i> ${t('welcome.manage')}
                        </button>
                    </div>
                </div>
                <div class="combo-list" id="user-combos">
                    <!-- User combos will be loaded here -->
                </div>
                </section>

                <footer class="welcome-footer">
                    <span>MultiStream · Metaloul</span>
                    <nav class="social-links">
                        <a href="https://discord.gg/pv4Ye4W9zZ" target="_blank" rel="noopener noreferrer" title="Discord"><i class="fab fa-discord"></i></a>
                        <a href="https://github.com/Metaloul/Multistream-v2" target="_blank" rel="noopener noreferrer" title="GitHub"><i class="fab fa-github"></i></a>
                    </nav>
                </footer>
            </main>
        `;
        
        // Assurez-vous que le conteneur a la classe welcome-screen
        if (!this.container.classList.contains('welcome-screen')) {
            this.container.classList.add('welcome-screen');
        }
        
        // Attacher les événements aux boutons
        document.getElementById('search-streamer-btn').addEventListener('click', () => {
            // Focus sur la barre de recherche
            const searchInput = document.getElementById('streamer-search');
            if (searchInput) {
                searchInput.focus();
            }
            // Activer l'onglet streamers
            if (window.app && window.app.sidebar) {
                window.app.sidebar.activateTab('streamers');
            }
        });
        
        document.getElementById('browse-combos-btn').addEventListener('click', () => {
            if (window.streamCombos) {
                window.streamCombos.openComboModal();
            }
        });

        document.getElementById('resume-streams-btn')?.addEventListener('click', () => this.hide());
        
        // Attacher l'événement au bouton manage
        document.getElementById('manage-all-combos-btn')?.addEventListener('click', () => {
            if (window.streamCombos) {
                window.streamCombos.openComboModal();
                window.streamCombos.switchTab('my-combos');
            }
        });
        
        // Charger les combos mis en avant
        this.loadFeaturedCombos();
        
        // Charger les combos de l'utilisateur
        this.loadUserCombos();
        this.updateResumeAction();
    }

    show() {
        this.container.style.display = 'flex';
        document.body.classList.add('welcome-screen-active');
        this.container.scrollTop = 0;
        this.updateResumeAction();
        this.updateHomeButtonState(true);
    }

    hide() {
        if (this.streamsContainer.children.length === 0) return;
        this.container.style.display = 'none';
        document.body.classList.remove('welcome-screen-active');
        this.updateHomeButtonState(false);
    }

    toggle() {
        const isVisible = this.container.style.display !== 'none';
        if (isVisible && this.streamsContainer.children.length > 0) {
            this.hide();
        } else {
            this.show();
        }
    }

    updateResumeAction() {
        const button = document.getElementById('resume-streams-btn');
        if (button) button.hidden = this.streamsContainer.children.length === 0;
    }

    updateHomeButtonState(isHomeVisible) {
        const button = document.getElementById('sidebar-home');
        if (!button) return;
        const key = isHomeVisible && this.streamsContainer.children.length > 0
            ? 'sidebar.resumeStreams'
            : 'sidebar.home';
        button.dataset.tooltip = t(key);
        button.setAttribute('aria-label', t(key));
    }
    
    /**
     * Charge les combos mis en avant
     */
    loadFeaturedCombos() {
        const featuredCombosContainer = document.getElementById('featured-combos');
        
        // Exemple de combos mis en avant (à remplacer par des données réelles)
        const featuredCombos = [
            {
                id: 'zevent2025',
                name: 'ZEvent 2025',
                description: 'ZEVENT, est un projet caritatif destiné à récolter des fonds par le biais du streaming pendant 3 jours.',
                language: 'fr',
                category: 'charitable',
                streamers: ['Alphacast', 'AngleDroit', 'AntoineDaniel', 'AVAMind', 'BagheraJones', 'byilhann', 'chowh1', 'Clemovitch', , 'CrocodyleTV', 'DamDamlive', 'Doigby', 'Domingo', 'DrFeelgood', 'EnjoyPhoenix', 'Etoiles', 'Flamby', 'Gius', 'Gom4rt', 'helydia', 'HortyUnderscore', 'Jirayalecochon', 'JLTomy', 'Joueur_du_Grenier', 'Joyca', 'KennyStream', 'Lapi', 'LittleBigWhale', 'm4fgaming', 'Mastu', 'mistermv', 'MoMaN', 'Mynthos', 'Nicola', 'Ponce', 'Pressea', 'Rivenzi', 'Sakor_', 'samueletienne', 'Shisheyu', 'Sundae', 'SylvainLyve', 'TheGreatReview', 'TheGuill84', 'theodort', 'Ultia', 'zacknani', 'Zerator']
            }
        ];
        
        // Générer les cards pour chaque combo
        featuredCombosContainer.innerHTML = featuredCombos.map(combo => `
            <div class="combo-card" data-combo-id="${combo.id}">
                <div class="combo-name">${combo.name}</div>
                <div class="combo-meta">
                    <span class="badge language">${this.getLanguageName(combo.language)}</span>
                    <span class="badge category">${this.getCategoryName(combo.category)}</span>
                </div>
                <div class="combo-streamers">
                    ${combo.streamers.map(streamer => `
                        <span class="combo-streamer-tag">${streamer}</span>
                    `).join('')}
                </div>
            </div>
        `).join('');
        
        // Ajouter les événements de clic pour charger les combos
        document.querySelectorAll('#featured-combos .combo-card').forEach(card => {
            card.addEventListener('click', () => {
                const comboId = card.dataset.comboId;
                const combo = featuredCombos.find(c => c.id === comboId);
                if (combo) {
                    // Utiliser la même méthode loadCombo que pour les combos utilisateur
                    this.loadCombo(combo);
                }
            });
        });
    }
    
    /**
     * Charge un combo en utilisant l'API backend
     */
    loadCombo(combo) {
        if (!combo || !combo.streamers || combo.streamers.length === 0) {
            return;
        }
        
        // Afficher une notification pour indiquer le chargement
        if (window.app) {
            window.app.showNotification(t('combos.loading', { name: combo.name }), 'info');
        }
        
        // NE PAS masquer l'écran d'accueil tout de suite - attendons de voir s'il y a des streams à afficher
        
        // Charger tous les streamers en une seule requête via l'API backend
        fetch('/api/streamers/load-multiple', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                usernames: combo.streamers
            })
        })
        .then(response => response.json())
        .then(data => {
            if (!data.success) {
                throw new Error(data.error || 'Error loading streamers');
            }
            
            if (!data.streamers || data.streamers.length === 0) {
                // Si aucun streamer n'est en direct, afficher un message mais garder l'écran d'accueil
                window.app.showNotification(data.message || t('combos.none'), 'warning');
                return; // Garder l'écran d'accueil visible
            }
            
            // Des streamers sont disponibles, maintenant on peut masquer l'écran d'accueil
            this.container.style.display = 'none';
            document.body.classList.remove('welcome-screen-active');
            
            // Ajouter tous les streamers à l'application
            if (window.app) {
                // Méthode pour rendre plusieurs streamers d'un coup
                window.app.renderStreamers(data.streamers);
                
                // Mettre à jour l'URL pour refléter les streamers chargés
                setTimeout(() => {
                    window.app.updateUrl();
                }, 500);
                
                // Notification de succès
                window.app.showNotification(
                    t('combos.loaded', { count: data.streamers.length, name: combo.name }),
                    'success'
                );
            }
        })
        .catch(error => {
            console.error('Error loading combo:', error);
            if (window.app) {
                window.app.showNotification(t('combos.loadError', { message: error.message }), 'error');
            }
        });
    }
    
    /**
     * Configure l'observateur pour détecter quand des streams sont affichés
     */
    setupStreamObserver() {
        // Observer les mutations dans le conteneur de streams
        const observer = new MutationObserver((mutations) => {
            this.checkStreamVisibility();
        });
        
        // Observer les changements d'enfants dans le conteneur
        observer.observe(this.streamsContainer, { childList: true });
        
        // Vérifier l'état initial
        this.checkStreamVisibility();
    }
    
    /**
     * Vérifie si des streams sont affichés et montre/cache l'écran d'accueil en conséquence
     */
    checkStreamVisibility() {
        if (this.streamsContainer.children.length > 0) {
            // Si des streams sont affichés, masquer l'écran d'accueil
            this.hide();
        } else {
            // Si aucun stream n'est affiché, montrer l'écran d'accueil
            this.show();
        }
        this.updateResumeAction();
    }
    
    /**
     * Obtient le nom lisible d'un code de langue
     */
    getLanguageName(code) {
        const languages = {
            'en': t('language.en'),
            'fr': t('language.fr'),
            'es': t('language.es'),
            'de': t('language.de'),
            'other': t('filters.other')
        };
        return languages[code] || code;
    }
    
    /**
     * Obtient le nom lisible d'une catégorie
     */
    getCategoryName(code) {
        const categories = {
            'gaming': t('filters.gaming'),
            'esports': t('filters.esports'),
            'talk': t('filters.talk'),
            'music': t('filters.music'),
            'other': t('filters.other')
        };
        return categories[code] || code;
    }
    
    // Ajouter cette nouvelle méthode pour charger les combos de l'utilisateur
    loadUserCombos() {
        const userCombosContainer = document.getElementById('user-combos');
        
        // Récupérer les combos utilisateur depuis le localStorage ou depuis l'objet streamCombos
        let userCombos = [];
        
        if (window.streamCombos && window.streamCombos.userCombos) {
            userCombos = window.streamCombos.userCombos;
        } else {
            // Essayer de récupérer depuis le localStorage
            try {
                const stored = localStorage.getItem('userCombos');
                if (stored) {
                    userCombos = JSON.parse(stored);
                }
            } catch (e) {
                console.error('Error loading user combos:', e);
            }
        }
        
        // Si aucun combo utilisateur, afficher un message
        if (!userCombos || userCombos.length === 0) {
            userCombosContainer.innerHTML = `
                <div class="empty-combo-message">
                    <i class="fas fa-layer-group"></i>
                    <p>${t('welcome.noCombos')}</p>
                    <button class="action-button" id="create-new-combo-btn">
                        <i class="fas fa-plus"></i> ${t('welcome.createFirst')}
                    </button>
                </div>
            `;
            
            // Ajouter l'événement pour créer un nouveau combo
            document.getElementById('create-new-combo-btn')?.addEventListener('click', () => {
                if (window.streamCombos) {
                    window.streamCombos.openComboModal();
                    // Aller directement à l'onglet My Combos et ouvrir la création
                    window.streamCombos.switchTab('my-combos');
                    window.streamCombos.openCreateComboModal();
                }
            });
            
            return;
        }
        
        // Trier les combos (plus récents en premier)
        const sortedCombos = [...userCombos].sort((a, b) => {
            const dateA = a.created ? new Date(a.created) : new Date(0);
            const dateB = b.created ? new Date(b.created) : new Date(0);
            return dateB - dateA;
        });
        
        // Limiter à 3 combos récents pour ne pas surcharger l'écran d'accueil
        const recentCombos = sortedCombos.slice(0, 3);
        
        // Générer les cards pour chaque combo
        userCombosContainer.innerHTML = recentCombos.map(combo => `
            <div class="combo-card" data-combo-id="${combo.id}">
                <div class="combo-card-header">
                    <div class="combo-name">${combo.name}</div>
                    <div class="combo-actions">
                        <button class="combo-edit-btn" data-combo-id="${combo.id}" title="Edit Combo">
                            <i class="fas fa-edit"></i>
                        </button>
                    </div>
                </div>
                <div class="combo-meta">
                    <span class="badge language">${this.getLanguageName(combo.language)}</span>
                    <span class="badge category">${this.getCategoryName(combo.category)}</span>
                </div>
                <div class="combo-streamers">
                    ${combo.streamers.map(streamer => `
                        <span class="combo-streamer-tag">${streamer}</span>
                    `).join('')}
                </div>
            </div>
        `).join('');
        
        // Ajouter les événements de clic pour charger les combos
        document.querySelectorAll('#user-combos .combo-card').forEach(card => {
            card.addEventListener('click', (e) => {
                // Ne pas déclencher si on a cliqué sur le bouton d'édition
                if (e.target.closest('.combo-edit-btn')) {
                    return;
                }
            
                const comboId = card.dataset.comboId;
                const combo = userCombos.find(c => c.id === comboId);
                if (combo) {
                    this.loadCombo(combo);
                }
            });
        });
        
        // Ajouter les événements pour éditer les combos
        document.querySelectorAll('.combo-edit-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.stopPropagation(); // Empêcher le chargement du combo
                const comboId = btn.dataset.comboId;
                if (window.streamCombos) {
                    window.streamCombos.openComboModal();
                    window.streamCombos.switchTab('my-combos');
                    window.streamCombos.openCreateComboModal(comboId);
                }
            });
        });
    }
}
